import { GuestModel } from 'api-hooks/guest';
import { SeparatorVertical } from 'legacy-modules/styles';
import * as React from 'react';

import AirlineMemberCard from './airline-member-card';
import GuestInformation from './guest-information';
import GuestPreferenceCard from './guest-preference-card';
import GuestRelationCard from './guest-relation-card';

interface Props {
  guest?: GuestModel;
}

export default function (props: Props) {
  return (
    <>
      <GuestInformation />
      <SeparatorVertical $margin={24} />
      <AirlineMemberCard />
      <SeparatorVertical $margin={24} />
      <GuestPreferenceCard guest={props.guest} />
      <SeparatorVertical $margin={24} />
      <GuestRelationCard guest={props.guest} />
    </>
  );
}
